import { startTransition, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import T from '@wojtekmaj/react-t';

import colors from '@rewardopl/styles/colors';

import Button from '@rewardopl/react-ui/button';

import { ButtonWrapper, ContentWrapper, PageWrapper, Title } from './index.styles';

import ScrollableSlides from './scrollable_slides';
import Slide from './slide';

import { scrollToChild } from '../../../utils/carousel';

import { configLoginLoadable } from '../../../store';

import onboarding1 from '../../../static/onboarding/onboarding-1.svg';
import onboarding2 from '../../../static/onboarding/onboarding-2.svg';
import onboarding3 from '../../../static/onboarding/onboarding-3.svg';
import onboarding4 from '../../../static/onboarding/onboarding-4.svg';
import onboarding5 from '../../../static/onboarding/onboarding-5.svg';

const slides = [
  {
    id: 1,
    fetchPriority: 'high',
    image: onboarding1,
    text: 'Welcome to Rewardo!',
  },
  {
    id: 2,
    image: onboarding2,
    text: 'Shop in your favorite places',
  },
  {
    id: 3,
    image: onboarding3,
    text: 'Collect stamps or points',
  },
  {
    id: 4,
    image: onboarding4,
    text: 'Exchange for rewards',
  },
  {
    id: 5,
    image: onboarding5,
    text: 'Take part in challenges',
  },
] as const;

export default function OnboardingPage() {
  const navigate = useNavigate();
  const scrollContainer = useRef<HTMLDivElement>(null);
  const [currentChildIndex, onChildChange] = useState(0);
  useAtomValue(configLoginLoadable);

  function navigateToLogin() {
    startTransition(() => {
      navigate('/login');
    });
  }

  function scrollToNext() {
    if (!scrollContainer.current) {
      return;
    }

    scrollToChild(currentChildIndex + 1, scrollContainer.current);
  }

  return (
    <>
      <meta content={colors['gray-light']} name="theme-color" />
      <PageWrapper>
        <ContentWrapper>
          <Title>
            <T>Welcome to Rewardo!</T>
          </Title>
          <ScrollableSlides onChildChange={onChildChange} scrollContainer={scrollContainer}>
            {slides.map((slide) => (
              <Slide key={slide.id} {...slide} />
            ))}
          </ScrollableSlides>
          <ButtonWrapper>
            {currentChildIndex === slides.length - 1 ? (
              <Button className="primary" key="next" onClick={navigateToLogin}>
                <T>Let’s begin</T>
              </Button>
            ) : (
              <>
                <Button key="skip" onClick={navigateToLogin}>
                  <T>Skip</T>
                </Button>
                <Button className="primary" key="next" onClick={scrollToNext} type="button">
                  <T>Next</T>
                </Button>
              </>
            )}
          </ButtonWrapper>
        </ContentWrapper>
      </PageWrapper>
    </>
  );
}
